// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-wrapper[data-v-913d8bae]{align-items:center;display:flex;height:100%;justify-content:center;overflow:hidden;width:100%;z-index:0}.fade[data-v-913d8bae]{backface-visibility:hidden}.fade-enter-active[data-v-913d8bae],.fade-leave-active[data-v-913d8bae]{transition:opacity 1s}.fade-enter[data-v-913d8bae],.fade-leave-to[data-v-913d8bae]{opacity:0}video[data-v-913d8bae]{pointer-events:none;visibility:visible;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
